'use strict';

import { toJS, observe } from "mobx";




function formatNumberInput (input) {
    input.value = input.value.replace(/[^0-9]/g,'');

    if ( input.value !== '' && input.value <= 0 ) {
        input.value = 1;
    }
}



function updateCartItemsOnPage (elemItems, items, gifts) {
    elemItems
        .forEach(elem => {
            const current = items.find(item => item.uniqueId === elem.dataset.uniqueid);
            if ( current  === undefined ) {
                elem.remove();
            } else {
              const price = elem.querySelector('.price:last-child')
                if ( price ) {
                    price.innerHTML = current.total;
                }
            }
        });



    // Show no products message
    const noProductsMsg = document.querySelector('.no-products-holder');
    const cartView = document.querySelector('.cart-view');
    if ( noProductsMsg && cartView && items.length === 0 ) {
        noProductsMsg.classList.remove('d-none');
        cartView.remove();
    }



    // Remove gifts
    const giftsHolder = document.querySelector('.gifts-holder');
    if ( giftsHolder ) {
        const hasGift = gifts.length > 0;
        if ( !hasGift ) {
            giftsHolder.classList.add('d-none');
        } else {
            giftsHolder.classList.remove('d-none');

            giftsHolder.querySelectorAll('.item')
                .forEach(item => {
                    if ( gifts.find(gift => gift.id == item.dataset.id) !== undefined ) {
                        item.classList.remove('d-none');
                    } else {
                        item.classList.add('d-none');
                    }
                });
        }
    }
}



export default function setupCart () {
    const changeQuantity = item => evt => {
        window.store.product.updateCart({
            id: item.dataset.id,
            uniqueId: item.dataset.uniqueid,
            type_: item.dataset.type,
            cartQuantity: evt.target.value,
        });
    };

    const deleteItem = item => () => {
        window.store.product.deleteCartItem({
            id: item.dataset.id,
            uniqueId: item.dataset.uniqueid,
            type_: item.dataset.type,
        });
    };


    if ( document.querySelector('.cart-view') ) {
        window.store.product.calculateCart();
    }


    const cartItems = document.querySelectorAll('.cart-view .cart-items .item, .order-overview  > .item');
    const cartCount = document.querySelector('.cart-count');

    if ( cartItems.length > 0 ) {
        cartItems
            .forEach(item => {
                const quantityInput = item.querySelector('input.quantity')

                if ( quantityInput ) {
                    quantityInput.addEventListener('change', changeQuantity(item));
                }

                const deleteBtn = item.querySelector('.delete')
                if ( deleteBtn ) {
                    deleteBtn.addEventListener('click', deleteItem(item));
                }
            });

        observe(window.store.product, 'cart', () => {
            const cart = toJS(window.store.product.cart);

            if ( cartCount ) {
                cartCount.innerHTML = cart.itemCount;
            }

            const nonGiftItems = [...cartItems].filter(item => item.dataset.type !== 'Gift');

            updateCartItemsOnPage(nonGiftItems, cart.items, cart.gifts);
        });
    }



    document.querySelectorAll('input.quantity')
        .forEach(input => {
            input.addEventListener('keyup', evt => formatNumberInput(evt.currentTarget));
        });

    document.querySelectorAll('input.quantity').forEach(input => formatNumberInput(input));
}
